// extracted by mini-css-extract-plugin
export default {"draggableRoot":"DraggablePhoto_draggableRoot__zcTXy","isDragging":"DraggablePhoto_isDragging__LybRP","countPhoto":"DraggablePhoto_countPhoto__iHvFk"};